import { configureStore } from '@reduxjs/toolkit';
import correcttrackReducer from './correcttrackSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
    key: 'root',
    storage,
    version: 1,
    // Nothing that can authenticate a request is written to localStorage. The access token is
    // kept in memory for the tab's lifetime and the refresh token is an httpOnly cookie, so an
    // XSS on the page has nothing to read and no session to steal.
    blacklist: ['userToken'],
    migrate: (state) => {
        if (!state) {
            return Promise.resolve(state);
        }

        // Version 0 persisted both tokens here. Clear whatever a returning user still has stored:
        // it is no longer read, and leaving credentials at rest is the thing being fixed. Their
        // current session ends at this point -- the server-side token stays valid until it
        // expires, but nothing will present it again.
        const cleaned = { ...state };
        delete cleaned.userToken;
        delete cleaned.refreshToken;
        return Promise.resolve(cleaned);
    },
};

const persistedReducer = persistReducer(persistConfig, correcttrackReducer);
export const correcttrackStore = configureStore({
    reducer: {
        correcttrack: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: true, // enable thunk
            serializableCheck: {
                ignoredActions: [
                    'persist/PERSIST',
                    'persist/REHYDRATE',
                    'persist/PAUSE',
                    'persist/FLUSH',
                    'persist/PURGE',
                    'persist/REGISTER',
                ],
            },
        }),
});

export const persistor = persistStore(correcttrackStore);
